import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'OCORRENCIA_MODO_TELA',
        payload: {
			modo: modo,
			registro: {
				...registro

			}
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('ocorrenciaForm', {
			...registro
		})
    ];
}

export function setAguardando(aguardando) {
    return {
        type: 'OCORRENCIA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista() {
	return (dispatch, getState) => {
		dispatch(setAguardando(true));
		axios.get(`${consts.API_URL}/ocorrencia`).then(resp => {
			dispatch({
				type: 'OCORRENCIA_LISTADO',
				payload: resp
			});
			dispatch(setAguardando(false));
		}).catch(ex => {
			console.log(ex);
			dispatch(setAguardando(false));
		});
	};
}

export function buscarImagens(id) {
	return (dispatch, getState) => {
	    axios.get(`${consts.API_URL}/ocorrencia/imagens?id=${id}`).then(retorno => {
			console.log({
				...getState().ocorrencia.registro,
				imagem: retorno.data ? retorno.data.imagem : null
			});
			dispatch(initForm({
				...getState().ocorrencia.registro,
				imagem: retorno.data ? retorno.data.imagem : null
			}));
		}).catch(ex => {
			console.log(ex);
		});
	};
}

export function salvar(registro) {
	
    return (dispatch, getState) => {
		dispatch(setAguardando(true));
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/ocorrencia`, {
				...registro,
                datahora_ocorrencia: DateFormat.formatarDataHoraTelaParaSql(registro.datahora_ocorrencia),
				modoMotorista: getState().auth.usuario.id_motorista || false
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
				dispatch(setAguardando(false));
			}).catch(e => {
				setErroAPI(e);
				dispatch(setAguardando(false));
			});
		} else {
			axios.put(`${consts.API_URL}/ocorrencia`, {
				...registro,
				datahora_ocorrencia: DateFormat.formatarDataHoraTelaParaSql(registro.datahora_ocorrencia),
				modoMotorista: getState().auth.usuario.id_motorista || false
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
				dispatch(setAguardando(false));
			}).catch(e => {
				setErroAPI(e);
				dispatch(setAguardando(false));
			});
		}
    };
}

export function excluir(registro) {
    return dispatch => {
		dispatch(setAguardando(true));
        axios.delete(`${consts.API_URL}/ocorrencia?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
    };
}

export function getListaMotorista() {
    const request = axios.get(`${consts.API_URL}/motorista/listarSelect`);
    return {
        type: 'OCORRENCIA_MOTORISTA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaVeiculo() {
    const request = axios.get(`${consts.API_URL}/veiculo/listarSelect`);
    return {
        type: 'OCORRENCIA_VEICULO_SELECT_LISTADO',
        payload: request
    };
}
